<template>
    <!-- 单选题 -->
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <!-- 单项打分 -->
            <div class="content" v-if="dataList.scoreType === 1">
                <!-- 单个打分项 -->
                <div class="score-box" v-if="dataList.icon === 'Number' || dataList.icon === 'NumberS'">
                    <div class="score-icon" v-for="(item, index) in dataList.score" :key="index">
                        <div
                            class="score-icon_number"
                            :style="{
                                background: index === 0 ? 'rgba(34, 64, 195, 1)' : '',
                                color: index === 0 ? '#fff' : '',
                                borderRadius: dataList.icon === 'Number' ? '50%' : 0,
                            }"
                        >
                            {{ item }}
                        </div>
                        <div v-if="dataList.showScoreExplain" class="score-explain">
                            <span v-show="index === 0">{{ dataList.miniScoreExplain }}</span>
                            <span v-show="index + 1 === dataList.score">{{ dataList.maxScoreExplain }}</span>
                        </div>
                    </div>
                </div>
                <div class="score-box" v-else-if="dataList.icon === 'Ruler'">
                    <div style="display: flex; flex-direction: column; margin-top: 10px">
                        <div class="score-ruler">
                            <div class="bar"></div>
                            <div class="bar-pointer"></div>
                        </div>
                        <ruler-score :score="dataList.score" />
                        <div v-if="dataList.showScoreExplain" class="score-explain">
                            <span>{{ dataList.miniScoreExplain }}</span>
                            <span>{{ dataList.maxScoreExplain }}</span>
                        </div>
                    </div>
                    <!-- <div class="score-icon" v-for="(item, index) in dataList.score" :key="index">
                        <div
                            class="score-icon_ruler"
                            :style="{
                                background: index === 0 ? 'rgba(34, 64, 195, 1)' : '',
                                color: index === 0 ? '#fff' : '',
                            }"
                        >
                            {{ item }}
                        </div>
                    </div> -->
                </div>
                <div v-else class="score-box">
                    <div class="score-icon" v-for="(item, index) in dataList.score">
                        <img v-if="index === 0" :src="getAssetsImages(dataList.icon + '_light')" />
                        <img v-else :src="getAssetsImages(dataList.icon)" />
                        <div v-if="dataList.showScoreExplain" class="score-explain">
                            <span v-show="index === 0">{{ dataList.miniScoreExplain }}</span>
                            <span v-show="index + 1 === dataList.score">{{ dataList.maxScoreExplain }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 多个打分项 -->

            <ul class="content" v-else>
                <div>
                    <draggable
                        :group="{
                            name: 'name1',
                            put: false,
                            pull: false,
                        }"
                        force-fallback="true"
                        v-model="mulContentList"
                        animation="300"
                        itemKey="value"
                        handle=".operation-drag"
                        ghostClass="option-ghost-class"
                    >
                        <template #item="{ element, index }">
                            <li class="content-item">
                                <div class="placeholder-content">
                                    <!-- 输入框 -->
                                    <rich-text-editor
                                        :key="index"
                                        ref="contetnRef"
                                        class="content-input"
                                        v-model:valueData="element.label"
                                        @mouseenter="() => (element.buttonShowHover = true)"
                                        @mouseleave="() => (element.buttonShowHover = false)"
                                        @focus="() => (element.buttonShow = true)"
                                        @blur="() => (element.buttonShow = false)"
                                    >
                                        <template #operation>
                                            <!-- 鼠标触摸展示的按钮 -->
                                            <div class="operation-box" v-show="element.buttonShow || element.buttonShowHover">
                                                <div class="operation-drag">
                                                    <el-tooltip content="长按拖动" effect="customized" placement="top">
                                                        <svg-icon name="operationDrag" class="svg-icon" />
                                                    </el-tooltip>
                                                </div>
                                                <div class="operation-delete" @click="deleteOption(index)">
                                                    <el-tooltip content="删除" effect="customized" placement="top">
                                                        <svg-icon name="operationDelete" class="svg-icon" />
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </template>
                                    </rich-text-editor>
                                    <div class="score-box" v-if="dataList.icon === 'Number' || dataList.icon === 'NumberS'">
                                        <div class="score-icon" v-for="(item, index) in dataList.score" :key="index">
                                            <div
                                                class="score-icon_number"
                                                :style="{
                                                    background: index === 0 ? 'rgba(34, 64, 195, 1)' : '',
                                                    color: index === 0 ? '#fff' : '',
                                                    borderRadius: dataList.icon === 'Number' ? '50%' : 0,
                                                }"
                                            >
                                                {{ item }}
                                            </div>
                                            <div v-if="dataList.showScoreExplain" class="score-explain">
                                                <span v-show="index === 0">{{ dataList.miniScoreExplain }}</span>
                                                <span v-show="index + 1 === dataList.score">{{ dataList.maxScoreExplain }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="score-box" v-else-if="dataList.icon === 'Ruler'">
                                        <div class="score-icon" v-for="(item, index) in dataList.score" :key="index">
                                            <div
                                                class="score-icon_ruler"
                                                :style="{
                                                    background: index === 0 ? 'rgba(34, 64, 195, 1)' : '',
                                                    color: index === 0 ? '#fff' : '',
                                                }"
                                            >
                                                {{ item }}
                                            </div>
                                            <div v-if="dataList.showScoreExplain" class="score-explain">
                                                <span v-show="index === 0">{{ dataList.miniScoreExplain }}</span>
                                                <span v-show="index + 1 === dataList.score">{{ dataList.maxScoreExplain }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else class="score-box">
                                        <div class="score-icon" v-for="(item, index) in dataList.score">
                                            <img v-if="index === 0" :src="getAssetsImages(dataList.icon + '_light')" />
                                            <img v-else :src="getAssetsImages(dataList.icon)" />
                                            <div v-if="dataList.showScoreExplain" class="score-explain">
                                                <span v-show="index === 0">{{ dataList.miniScoreExplain }}</span>
                                                <span v-show="index + 1 === dataList.score">{{ dataList.maxScoreExplain }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </draggable>
                </div>
            </ul>
            <!-- 底部操作栏 -->
            <div class="footer-operation">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                >
                    <!-- 添加左侧操作按钮 -->
                    <template #operation>
                        <div class="bottom-operation" v-if="dataList.type === 2">
                            <div class="button1" @click="addSingleOption"><svg-icon name="addOption" class="icon" />添加评分项</div>
                            <div class="button1" @click="openBatchDialog"><svg-icon name="batchEdit" class="icon" />批量编辑评分项</div>
                        </div>
                    </template>
                </action-bar>
            </div>
            <batch-edit ref="batchEdit" :optionsList="mulContentList" @confirmOption="confirmOption" />
        </div>
    </div>
</template>
<script setup name="kr-score">
// js
import Draggable from "vuedraggable";
import { ref, watch, provide } from "vue";

// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import BatchEdit from "@/components/dialog/BatchEdit.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";
import RulerScore from "@/components/scoreIcon/RulerScore.vue";

import { getAssetsImages } from "@/utils/index";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
let mulContentList = ref([]);
mulContentList.value = props.dataList.mulContent;
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]); // 复制题目，删除题目, 数据改变, 单题预览;
const batchEdit = ref(null);
const titileInput = ref(null);

watch(
    () => props.dataList,
    (curr, old) => {
        // 绑定数据改变时调change方法
        emits("change", curr);
    },
    { deep: true }
);

// 可能会在外面改变内部输入框的聚焦情况
defineExpose({ titileInput });

provide("data", props.dataList);

// 打开批量编辑选项弹框
const openBatchDialog = () => {
    batchEdit.value.dialogVisible = true;
    batchEdit.value.newOption = "";
};
// 添加单个评分项
const addSingleOption = () => {
    let defaultHolder = `评分项${mulContentList.value.length + 1}`;
    let obj = {
        label: defaultHolder,
        value: mulContentList.value.length + 1,
    };
    mulContentList.value.push(obj);
};
const confirmOption = (data) => {
    mulContentList.value = data;
};
// 删除当前选项
const deleteOption = (index) => {
    mulContentList.value.splice(index, 1);
};
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;
.content {
    margin-left: 0px !important;
    width: calc(100% - 200px);
    .score-box {
        display: flex;
        padding-left: 6px;

        .score-icon {
            width: 32px;
            min-height: 32px;
            margin-right: 25px;
            display: flex;
            flex-direction: column;
            white-space: nowrap;

            img {
                width: 32px;
                height: 32px;
            }
        }
        .score-icon_ruler {
            width: 32px;
            height: 32px;
            border: 1px solid rgba(228, 229, 232, 1);
            color: rgba(102, 102, 102, 1);
            line-height: 30px;
            text-align: center;
        }
        .score-icon_number {
            width: 32px;
            height: 32px;
            border: 1px solid rgba(228, 229, 232, 1);
            color: rgba(102, 102, 102, 1);
            border-radius: 50%;
            line-height: 30px;
            text-align: center;
        }
        .score-explain {
            width: 100%;
            height: 18px;
            margin-top: 10px;
            color: rgba(112, 120, 134, 1);
            font-size: 12px;
            position: relative;
            span {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                &:nth-child(1) {
                    left: 0;
                }
                &:nth-child(2) {
                    right: 0;
                }
            }
        }
    }
    .icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 14px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #ccc;
        background-color: #fff;
    }
    .content-item {
        // background-color: #fff;
        position: relative;
        margin-bottom: 18px;
        .content-input {
            width: calc(100% - 110px);
            color: rgba(112, 120, 134, 1) !important;
        }

        &:hover .input-box {
            border: 1px dashed rgba(0, 0, 0, 0.4);
        }
        .operation-box {
            display: flex;
            align-items: center;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(100%, -50%);
            color: #9aa1ad;
        }
        .left-drag-icon,
        .operation-delete,
        .operation-add,
        .operation-drag {
            width: 18px;
            height: 18px;
            margin-left: 10px;
            cursor: pointer;
            .svg-icon {
                width: 100%;
                height: 100%;
                &:hover {
                    color: rgb(34, 64, 195);
                }
            }
        }
        .operation-delete .svg-icon:hover {
            color: red;
        }
    }
    .bottom-operation {
        .button1 {
            cursor: pointer;
            &:first-child {
                margin-right: 30px;
            }
        }
    }
}
</style>
